import React from "react";
import { Link, usePage } from "@inertiajs/react";
import fontan from "../images/menu/fontan.webp";
import { taxon_path } from "@/routes";

const images = import.meta.glob("../images/menu/menu/*.webp", {
  eager: true,
  as: "url",
});
const menuImages = Object.values(images);

import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  NavigationMenuTrigger,
  navigationMenuTriggerStyle,
} from "@/components/ui/navigation-menu";
import { cn } from "@/lib/utils";
import { catalog_path, contacts_path } from "@/routes.js";
import services from "@/components/home/Services/services.js";
import information from "../data/information";

export default function DesktopNavigation() {
  return <NavigationMenuDemo />;
}

const NavigationMenuDemo = () => {
  const { taxons } = usePage().props;

  const navItemClassName = "";
  const navItemTriggerClassName = "";
  return (
    <div className="max-lg:hidden">
      <NavigationMenu viewport={false}>
        <NavigationMenuList>
          <NavigationMenuItem>
            <NavigationMenuTrigger>
              <Link href={catalog_path()} className={"size-full"}>
                Каталог
              </Link>
            </NavigationMenuTrigger>
            <NavigationMenuContent>
              <ul className="grid grid-cols-2 gap-3 p-6 md:w-[400px] lg:w-[700px] __lg:grid-cols-[.75fr_1fr]">
                {taxons.map((t, i) => (
                  <ListItem
                    key={`desktop-nav-item-${i}`}
                    href={taxon_path(t.permalink)}
                  >
                    <div className="flex space-x-3">
                      <div className="w-20 h-full flex-none rounded overflow-hidden">
                        <img src={`${t.thumb}`} className="size-full" />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-base font-bold">{t.pretty_name}</h3>
                        <div
                          className="line-clamp-3 text-xs"
                          dangerouslySetInnerHTML={{
                            __html: t.description.body,
                          }}
                        />
                      </div>
                    </div>
                  </ListItem>
                ))}
              </ul>
            </NavigationMenuContent>
          </NavigationMenuItem>

          <NavigationMenuItem className={navItemClassName}>
            <NavigationMenuTrigger className={navItemTriggerClassName}>
              Услуги
            </NavigationMenuTrigger>
            <NavigationMenuContent>
              <ul className="m-0 grid list-none gap-x-2.5 p-[22px] sm:w-[600px] grid-cols-2">
                {services.map((service, n) => (
                  <ListItem
                    key={`nav-item-${n}`}
                    title={service.name}
                    href={service.url}
                    className="text-2xl"
                  >
                    <div className="flex items-center space-x-2 textarea-sm">
                      <img
                        src={service.image}
                        className="size-8 rounded-full"
                      />
                      <div className="leading-tight text-accent-content/70">
                        Новая задача количественный существенных особенности
                        также важные развития.
                      </div>
                    </div>
                  </ListItem>
                ))}
              </ul>
            </NavigationMenuContent>
          </NavigationMenuItem>

          <NavigationMenuItem className={navItemClassName}>
            <NavigationMenuTrigger>
              <div>Информация</div>
            </NavigationMenuTrigger>
            <NavigationMenuContent className="min-w-[200px] p-6">
              <ul className="grid">
                {information.map((item, i) => (
                  <li key={`information-item-${i}`}>
                    <NavigationMenuLink>
                      <Link
                        className="text-gray-700 transition hover:opacity-75"
                        href={item.link}
                      >
                        {item.name}
                      </Link>
                    </NavigationMenuLink>
                  </li>
                ))}
              </ul>
            </NavigationMenuContent>
          </NavigationMenuItem>
        </NavigationMenuList>
      </NavigationMenu>
    </div>
  );
};

const ListItem = React.forwardRef(
  ({ className, title, children, ...props }, ref) => {
    return (
      <li>
        <NavigationMenuLink asChild>
          <a
            ref={ref}
            className={cn(
              "block select-none space-y-1 rounded-md p-3 leading-none no-underline outline-none transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground",
              className
            )}
            {...props}
          >
            <div className="text-lg font-medium leading-none">{title}</div>
            <div className="line-clamp-2 text-md leading-snug text-muted-foreground">
              {children}
            </div>
          </a>
        </NavigationMenuLink>
      </li>
    );
  }
);
ListItem.displayName = "ListItem";
